import { Download, FileUp, RefreshCw } from "lucide-react";

const STEPS = [
  {
    icon: FileUp,
    number: "01",
    title: "选择 PDF",
    copy: "拖拽或选择 25 MiB 以内的 PDF，文件会直接上传到私有存储。",
  },
  {
    icon: RefreshCw,
    number: "02",
    title: "开始转换",
    copy: "文件校验完成后点击转换，处理期间请保持当前页面打开。",
  },
  {
    icon: Download,
    number: "03",
    title: "下载文件",
    copy: "转换成功后可分别下载 Word 和原 PDF，关闭页面后无法再找回。",
  },
] as const;

export function GuidePage() {
  return (
    <main className="guide-page">
      <div className="guide-heading">
        <span className="eyebrow">使用说明</span>
        <h1>三步完成转换</h1>
        <p>不需注册，不保存处理历史。</p>
      </div>
      <section className="guide-grid">
        {STEPS.map(({ icon: Icon, number, title, copy }) => (
          <article className="guide-card" key={number}>
            <span className="guide-number">{number}</span>
            <span className="guide-icon">
              <Icon size={28} />
            </span>
            <h2>{title}</h2>
            <p>{copy}</p>
          </article>
        ))}
      </section>
      <section className="privacy-note">
        <h2>文件生命周期</h2>
        <p>
          原 PDF 和 DOCX
          只绑定在当前浏览器标签页的临时会话中。关闭页面时会发送清理请求；如果请求被浏览器中断，服务端会在
          10 分钟内自动清理。
        </p>
      </section>
    </main>
  );
}
